export default __webpack_public_path__ + "static/media/screen18.30d61cf8.svg";